import React from 'react';
import { Box, Avatar, Typography } from '@mui/material';
import { IUser } from '../../../../models/iuser';

type Props = {
  user: IUser,
}

const UserCard: React.FC<Props> = ({ user }) => {
  const { name, access, photo } = user;
  const userAccess = access[0];
  return ( <Box sx={styles.cardContainer}>
    {photo?.url ?
      <Avatar src={photo.url} sx={styles.avatar} />
      :
      <Avatar sx={styles.avatarSmallText}>
        FOTO
      </Avatar>
    }
    <Box sx={{display: 'flex', flexDirection: 'column', marginLeft: '1rem'}}>
      <Typography variant='subtitle1' fontWeight={600}>{name}</Typography>
      <Typography variant='caption'>{userAccess.role}</Typography>
      { userAccess.company && <Typography variant='caption'>{userAccess.company.name}</Typography>}
    </Box>
  </Box>);
};

export default UserCard;

const styles = {
  cardContainer: {
    height: '7rem',
    minHeight: '50px',
    background: 'white',
    border: '1px solid lightGray',
    borderRadius: '5px',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '1rem 0.5rem',
    marginBottom: '10px',
    width: '23rem'
  },
  avatarSmallText: {
    fontSize: '0.75rem',
    width: '3rem',
    height: '3rem',
    marginLeft: '0.25rem',
  },
  avatar: {
    width: '3rem',
    height: '3rem',
    marginLeft: '0.25rem',
  },
};
